import { defineComponent as e, openBlock as a, createElementBlock as t, normalizeClass as r, renderSlot as i } from "vue";
import '../assets/BaseBadge.css';const o = ["id"], p = /* @__PURE__ */ e({
  inheritAttrs: !1,
  __name: "BaseBadge",
  props: {
    badgeClass: { default: "uikit-badge-w-primary-sm" }
  },
  setup(n) {
    return (s, d) => (a(), t("span", {
      id: s.$attrs.id,
      class: r(["uikit-badge uikit-shadow-sm", s.badgeClass, s.$attrs.class])
    }, [
      i(s.$slots, "default")
    ], 10, o));
  }
});
export {
  p as _
};
